import React, { useState, useRef } from 'react';

const InlineVideo = ({ src, imageStyle, getFreshSrc }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);
  const videoRef = useRef(null);

  const handlePlay = async () => {
    // The preview frame may have been fetched long ago and Twilio temporary
    // URLs expire after ~5 minutes, so re-fetch a fresh URL before playback
    if (getFreshSrc) {
      try {
        const fresh = await getFreshSrc();
        if (fresh) {
          setCurrentSrc(fresh);
        }
      } catch (e) {
        console.warn("InlineVideo: failed to refresh video URL:", e);
      }
    }
    setIsPlaying(true);
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play()?.catch((e) => console.warn("InlineVideo: play failed:", e));
      }
    }, 0);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (videoRef.current) {
      videoRef.current.currentTime = 0.5;
    }
  };

  return (
    <div style={{ ...styles.container, cursor: isPlaying ? "default" : "pointer" }}
      onClick={!isPlaying ? handlePlay : undefined}
    >
      <video
        ref={videoRef}
        src={currentSrc + "#t=0.5"}
        preload="metadata"
        style={imageStyle}
        width="100%"
        controls={isPlaying}
        playsInline
        onEnded={handleEnded}
      />
      {!isPlaying && (
        <div style={styles.overlay}>
          <div style={styles.playButton}>&#9654;</div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    display: "inline-block",
    maxWidth: "250px",
  },
  overlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
  },
  playButton: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "18px",
    paddingLeft: "3px",
  },
};

export default InlineVideo;
